import Footer from './components/Footer';

export default Footer;
